export enum externalPartnersUrls {
    partnersAssistive = "partner-assistive",
    partnersDepartments = "partner-departments"
  }
  